import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { McuMatrixResponse, McuParticipant } from 'src/app/shared/model/mcu-matrix.model';
import { protectedResources } from '../auth-config';

@Injectable({ providedIn: 'root' })
export class McuMatrixService {
  private url = protectedResources.starhealthapi.endpoint;

  constructor(private http: HttpClient) {}

  getMatrix(search: string, order: string, page: number, max: number, periodYear: number, filters?: any) {
    let params = `search=${search}&order=${order}&page=${page}&max=${max}&periodYear=${periodYear}`;
    if (filters) {
      if (filters.empId) params += `&empId=${encodeURIComponent(filters.empId)}`;
      if (filters.company) params += `&company=${encodeURIComponent(filters.company)}`;
      if (filters.empName) params += `&empName=${encodeURIComponent(filters.empName)}`;
      if (filters.spouseName) params += `&spouseName=${encodeURIComponent(filters.spouseName)}`;
      if (filters.confirmationStatus) params += `&confirmationStatus=${encodeURIComponent(filters.confirmationStatus)}`;
      if (filters.spouseEligible) params += `&spouseEligible=${encodeURIComponent(filters.spouseEligible)}`;
      if (filters.workingArea) params += `&workingArea=${encodeURIComponent(filters.workingArea)}`;
    }
    return this.http.get<any>(`${this.url}/McuMatrix/getMatrix?${params}`).pipe(
      map(res => ({
        data:  res.Data  ?? res.data  ?? [],
        total: res.Total ?? res.total ?? 0,
        totalSpouseEligible: res.TotalSpouseEligible ?? res.totalSpouseEligible ?? 0,
      }))
    );
  }

  getPeriodYears() {
    return this.http.get<any>(`${this.url}/McuMatrix/getPeriodYears`
    ).pipe(
        map(res => (res as number[]) ?? [new Date().getFullYear()])
    );
  }

  generateFromMaster(periodYear: number) {
    return this.http.post<any>(`${this.url}/McuMatrix/generateFromMaster`, { periodYear }
    ).pipe(
        map(res => ({
            inserted: res.Inserted ?? res.inserted ?? 0,
            message:  res.Message  ?? res.message  ?? '',
            error:    res.Error    ?? res.error    ?? false,
        }))
    );
  }

  saveMatrix(participants: McuParticipant[]) {
    return this.http.post<any>(`${this.url}/McuMatrix/saveMatrix`, participants
    ).pipe(map(res => res));
  }

  downloadMatrix(search: string, periodYear: number) {
    const year = periodYear || new Date().getFullYear();
    const object: Object = { 'search': search };
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
  });
  
    return this.http.post(`${this.url}/McuMatrix/downloadExcel?search=${search}&periodYear=${year}`, object, { headers: headers, responseType: 'blob' })
      .pipe(
        map((res: any) => {
          return res;
      }));
  }
}